<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="'UPDATE CHART STAFF'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="update-chart-manage-popup" @submit.prevent="handleSubmit(onClickUpdateChart)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input disabled v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Staff</small>
                <v-select multiple :clearable="false" placeholder="" v-model="form.staffs" label="name"
                          :closeOnSelect="false"
                          :options="staffs" :reduce="option => option.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row">
            <vs-button v-if="form.staffs.length !== staffs.length" @click.stop="onClickSelectAll" size="small" class="ml-4">Select all</vs-button>
            <vs-button v-if="form.staffs.length > 0" @click.stop="form.staffs = []" color="danger" size="small" class="ml-4">Clear all</vs-button>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-manage-reports-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const StaffRepository = RepositoryFactory.get('staff');
const ReportingRepository = RepositoryFactory.get('reporting');
const DropDownRepository = RepositoryFactory.get('drop_down')

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    staffs: [],
    form: {
      staffs: []
    },
  }
}

export default {
  name: 'UpdateChartManagePopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    async openPopup(data) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchStaffs()
        Object.assign(this.form, data)
        this.form.staffs = this.form.staffs.map((x) => x.id)
        this.form.name = data.name
      } catch (error) {

      }
    },
    async fetchStaffs() {
      await this.$vs.loading({
        container: '#update-chart-manage-popup',
        scale: 0.45
      })

      try {
        const { data } = (await DropDownRepository.getStaffList()).data
        this.staffs = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close('#update-chart-manage-popup > .con-vs-loading')
    },
    onClickSelectAll() {
      this.form.staffs = this.staffs.map((x) => x.id)
    },
    async onClickUpdateChart() {
      const vue = this;
      await this.$vs.loading({
        container: '#update-chart-manage-popup',
        scale: 0.45
      })
      try {
        await ReportingRepository.updateChartManage(this.form.id, { staffs: this.form.staffs });
        this.showSuccessMessage('Chart manage updated successfully');
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#update-chart-manage-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-carrier >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}

</style>
